<template>
    <li class="nav-item dropdown" id="call-history-menu-item" v-if="$hasPermission('requests.calls.history.show')">
        <audio id="audio_notification" src="/sounds/notification.mp3"></audio>
        <a class="nav-icon" href="#" @click.prevent="callHistoryVisible = true">
            <img src="/svg/sidebar-history-normal.svg" alt="" style="width: 25px;height: 25px;">
            <span v-if="missed.length" class="badge badge-danger counter">{{missed.length}}</span>
        </a>
        <ModalCallHistory v-if="callHistoryVisible" :visibleModal.sync="callHistoryVisible"/>
    </li>
</template>

<script>
    import ModalCallHistory from "./ModalCallHistory";
    import axios from "axios";
    export default {
        name: "CallHistory",
        components: {ModalCallHistory},
        data: () => ({
            callHistoryVisible: false,
            missed: [],
            ids: [],
            echo_channels: [],
        }),
        mounted() {
            let self = this;
            this.fetchMissed();
            if (this.$store.getters['auth/user'].call_centers && this.$store.getters['auth/user'].call_centers.length) {
                _.forEach(this.$store.getters['auth/user'].call_centers, (cc) => {
                    this.echo_channels.push(`call_center.${cc.id}`);
                    Echo.private(`call_center.${cc.id}`)
                        .listen('.call.missed', function (e) {
                            self.pushNewMissedCall(e.call);
                        })
                })
            }
            this.echo_channels.push(`user.${this.$store.getters['auth/user'].id}`);
            Echo.private(`user.${this.$store.getters['auth/user'].id}`)
                .listen('.call.missed', function (e) {
                    self.pushNewMissedCall(e.call);
                })
                .listen('.call.callback_performed', function (e) {
                    self.fetchMissed();
                })
            this.$bus.$on(['call_history:open_modal'], function () {
                let ls = localStorage.getItem('calls-missed-viewed') ? JSON.parse(localStorage.getItem('calls-missed-viewed')) : [];
                localStorage.setItem('calls-missed-viewed', JSON.stringify(_.concat(ls, self.ids)));
                self.clear();
            });
        },
        beforeDestroy() {
            this.$bus.$off(['call_history:open_modal']);
          _.forEach(this.echo_channels, c => {
            Echo.leave(c);
          })
        },
        methods: {
            pushNewMissedCall(call) {
              if (!this.ids.includes(call.id)) {
                this.ids.push(call.id);
                this.missed.unshift(call);
                this.pushAlert(call);
              }
            },
            fetchMissed(alerts = false) {
                let self = this;
                axios.get('/api/calls/missed')
                    .then(function (response) {
                        let new_ids = [];
                        let missed = [];
                        let ls = localStorage.getItem('calls-missed-viewed') ? JSON.parse(localStorage.getItem('calls-missed-viewed')) : [];
                        let new_ls = [];
                        response.data.forEach(function (item) {
                            if (ls.indexOf(item.id) === -1) {
                                missed.push(item);
                                new_ids.push(item.id);
                                if (alerts && self.ids.indexOf(item.id) === -1) {
                                    self.pushAlert(item);
                                }
                            } else {
                                new_ls.push(item.id);
                            }
                        });
                        self.ids = new_ids;
                        self.missed = missed;
                        localStorage.setItem('calls-missed-viewed', JSON.stringify(new_ls));
                    });
            },
            clear() {
                this.ids = [];
                this.missed = [];
            },
            pushAlert(call) {
                let self = this;
                this.$vs.notification({
                    position: 'bottom-right',
                    duration: 5000,
                    title: 'Пропущенный звонок! Заявка №' + call.request_id,
                    clickClose: true,
                    onClick: function () {
                        self.clickAlert(call);
                    }
                });
                try {
                    audio_notification.play();
                } catch (e) {

                }
            },
            clickAlert(call) {
                this.removeItem(call.id);
                this.toRequest(call.request_id);
            },
            toRequest(id) {
                this.$router.push({
                    name: 'request',
                    params: {
                        id: id
                    }
                });
            },
            removeItem(id) {
                this.missed = _.filter(this.missed, function (item) {
                    return item.id !== id;
                });
                this.ids = _.filter(this.ids, function (item) {
                    return item !== id;
                });
                let ls = localStorage.getItem('calls-missed-viewed') ? JSON.parse(localStorage.getItem('calls-missed-viewed')) : [];
                localStorage.setItem('calls-missed-viewed', JSON.stringify(_.concat(ls, id)));
            }
        }
    }
</script>

<style scoped>
    #call-history-menu-item .counter {
        font-size: 0.8rem;
        position: absolute;
        top: 4px;
        left: 24px;
        padding: 3px;
    }
</style>
